exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Global */\n/* MOBILE */\n/* Modal */\n/* Header - Navbar */\n/* Footer */\n.List_List__XzrzI {\n  display: grid;\n  grid-template-columns: 1fr;\n  padding: 20px 60px;\n  max-height: calc(100vh - 63px);\n  overflow: auto; }\n  @media only screen and (max-width: 767px) {\n    .List_List__XzrzI {\n      padding: 20px 10px; } }\n\n.List_Footer__3k9EV {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 15px 0; }\n", ""]);

// Exports
exports.locals = {
	"List": "List_List__XzrzI",
	"Footer": "List_Footer__3k9EV"
};